import {Link} from "react-router-dom"

export default function SurveyComplete() {
    return (
        <div className="py-10">
            <h1 className="fw-bold fs-2x">Submission Complete</h1>
            <div className="d-flex flex-row gap-6 mt-10">
                <Link to="/home" className="btn btn-primary min-w-150px">
                    Home
                </Link>
                <Link to="/logoutnav" className="btn btn-primary min-w-150px">
                    Log Out
                </Link>
            </div>
        </div>
    )
}
